"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[6150],{

/***/ 6150:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ marquee)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


/**
  JS Section: sections/marquee.liquid, 
  * JS Elements: [data-component="marquee"] and [data-hook="marquee-track"]
  * Populates the marquee with duplicate tracks to fill the screen
  * Turns `on` the marquee wrapper
*/

function marquee({ wrapper }) {
  const { classes } = window.config

  const selectors = {
    track: '[data-hook="marquee-track"]',
  }

  const cache = {
    $section: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).closest('.shopify-section'),
    $wrapper: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper),
    $track: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.track),
    $clones: jquery__WEBPACK_IMPORTED_MODULE_0___default()(),
  }

  let prevWidth = window.innerWidth
  let sectionIsSelected = typeof Shopify !== 'undefined' && !Shopify.designMode

  ;(function initializeClones() {
    const marqueeIsValid = validateMarquee()
    if (marqueeIsValid) createTrackClone()

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', handleResize)

    listenForDesignMode()
  })()

  function listenForDesignMode() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:select', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).is(cache.$section)) {
        sectionIsSelected = true
        reset()
      }
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('shopify:section:deselect', function (event) {
      if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.target).is(cache.$section)) {
        sectionIsSelected = false
        reset()
      }
    })
  }

  function reset() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass(classes.active)

    removeClones()

    const marqueeIsValid = validateMarquee()
    if (marqueeIsValid) createTrackClone()
  }

  function handleResize() {
    if (window.innerWidth == prevWidth) return
    prevWidth = window.innerWidth

    reset()
  }

  // Ensure the marquee is visible and enabled
  function validateMarquee() {
    // Check if the marquee is wide enough to overflow the page
    const isOverflowing = cache.$track.width() >= cache.$wrapper.width()
    const ignoreOverflow = !wrapper.hasAttribute('data-watch-overflow')

    return jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is(':visible') && (isOverflowing || ignoreOverflow) && sectionIsSelected
  }

  function removeClones() {
    cache.$clones.remove()
    cache.$clones = jquery__WEBPACK_IMPORTED_MODULE_0___default()()
  }

  function createTrackClone() {
    if (!cache.$wrapper.is(':visible')) return

    let width = cache.$wrapper.width()
    let trackWidth = cache.$track.width()

    let widthDivider = Math.ceil(width / trackWidth)

    for (let index = 0; index < widthDivider; index++) {
      let $clone = cache.$track.clone()
      $clone.attr('aria-hidden', true)
      cache.$wrapper.append($clone)
      cache.$clones = cache.$clones.add($clone)
    }

    cache.$wrapper.find('video').prop('muted', true)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass(classes.active)
  }
}


/***/ })

}]);